import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLaptop = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 20C0.716667 20 0.479333 19.904 0.288 19.712C0.096 19.5207 0 19.2833 0 19C0 18.7167 0.096 18.4793 0.288 18.288C0.479333 18.096 0.716667 18 1 18H4V17C3.45 17 2.97933 16.8043 2.588 16.413C2.196 16.021 2 15.55 2 15V5C2 4.45 2.196 3.979 2.588 3.587C2.97933 3.19567 3.45 3 4 3H20C20.55 3 21.021 3.19567 21.413 3.587C21.8043 3.979 22 4.45 22 5V15C22 15.55 21.8043 16.021 21.413 16.413C21.021 16.8043 20.55 17 20 17V18H23C23.2833 18 23.5207 18.096 23.712 18.288C23.904 18.4793 24 18.7167 24 19C24 19.2833 23.904 19.5207 23.712 19.712C23.5207 19.904 23.2833 20 23 20H1ZM4 15H20V5H4V15Z",
		fill: "currentColor"
	})
});
export default SvgLaptop;
